import { useCallback, useEffect, useState } from "react";
import { getSemaforo } from "../services/semaforoService";

export const useSemaforo = (filtros) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSemaforo = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const result = await getSemaforo(filtros);

      setData(result);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => {
    fetchSemaforo();
  }, [fetchSemaforo]);

  const refresh = useCallback(() => {
    fetchSemaforo();
  }, [fetchSemaforo]);

  return {
    data,
    loading,
    error,
    refresh,
  };
};
